<template>
  <div class="cps-identifier container">
    <h2 v-if="creationMode" class="identifier-title">
      {{ $texts.formIdentifierWithPasswordTitle }}
    </h2>
    <h2 v-else class="identifier-title">{{ $texts.formIdentifierTitle }}</h2>

    <input-field
      v-if="
        formData.field_Login && formData.field_Login.visible && creationMode
      "
      fieldId="Login"
      :name="formData.field_Login.name"
      :description="formData.field_Login.description"
      :tooltip="formData.field_Login.tooltip"
      :required="formData.field_Login.required"
      :enabled="formData.field_Login.enabled"
      :pattern="formData.field_Login.regexp"
      v-model="userData.login"
    ></input-field>
    <input-fixed-field
      v-else-if="formData.field_Login && formData.field_Login.visible"
      fieldId="Login"
      :name="formData.field_Login.name"
      :description="formData.field_Login.description"
      :tooltip="formData.field_Login.tooltip"
      :required="formData.field_Login.required"
      :enabled="formData.field_Login.enabled"
      :pattern="formData.field_Login.regexp"
      v-model="userData.login"
    ></input-fixed-field>

    <div v-if="creationMode">
      <input-field
        v-if="formData.field_Password && formData.field_Password.visible"
        fieldId="Password"
        :name="formData.field_Password.name"
        :description="formData.field_Password.description"
        :tooltip="formData.field_Password.tooltip"
        :required="formData.field_Password.required"
        :enabled="formData.field_Password.enabled"
        :pattern="formData.field_Password.regexp"
        v-model="userData.password"
        type="password"
      ></input-field>
      <input-field
        v-if="
          formData.field_ConfirmPassword &&
            formData.field_ConfirmPassword.visible
        "
        fieldId="ConfirmPassword"
        :name="formData.field_ConfirmPassword.name"
        :description="formData.field_ConfirmPassword.description"
        :tooltip="formData.field_ConfirmPassword.tooltip"
        :required="formData.field_ConfirmPassword.required"
        :enabled="formData.field_ConfirmPassword.enabled"
        :pattern="formData.field_ConfirmPassword.regexp"
        v-model="userData.confirmPassword"
        type="password"
        :customRules="{ confirmed: 'Password' }"
      ></input-field>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import InputField from "../fields/InputField.vue";
import InputFixedField from "../fields/InputFixedField.vue";
import { AccountLoginGenerationService } from "../../services/AccountLoginGenerationService";
import { RegistrationSubMode } from "../../models/enums/RegistrationSubMode";

export default Vue.extend({
  name: "cps-identifier-fields",

  components: {
    InputField,
    InputFixedField,
  },

  props: {
    userData: {
      type: Object,
      required: true,
    },
    formData: {
      type: Object,
      required: true,
    },
    registrationData: {
      type: Object,
      required: true,
    },
    creationMode: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      accountLoginGenerationTimeoutId: 0,
    };
  },
  mounted() {
    this.refreshLogin();
  },
  computed: {},

  methods: {
    async refreshLogin() {
      if (!this.isAuthentified()) {
        let nom = "";
        let prenom = "";
        if (this.userData.lastName !== null) {
          nom = this.removeSpaces(this.registrationData.user.lastName);
        }
        if (this.firstName !== null) {
          prenom = this.removeSpaces(this.userData.firstName);
        }
        // login generation from webservice if enabled
        if (this.$appSettings.LoginGenerationEnabled) {
          if (nom && prenom) {
            if (this.accountLoginGenerationTimeoutId) {
              clearTimeout(this.accountLoginGenerationTimeoutId);
            }

            this.accountLoginGenerationTimeoutId = setTimeout(async () => {
              this.userData.login = await AccountLoginGenerationService.GenerateLogin(
                prenom,
                nom
              );

              this.accountLoginGenerationTimeoutId = 0;
            }, 350);
          } else {
            // either the first or last name was not written, or one of the two was there and the user deleted them
            this.registrationData.user.login = "";
          }
        } else {
          this.registrationData.user.login = `${prenom.toLowerCase()}${nom.toLowerCase()}`;
        }
      }
    },

    removeSpaces(chaine) {
      return chaine.trim();
    },
    isAuthentified() {
      return (
        this.registrationData.registrationSubMode ==
          RegistrationSubMode.Update ||
        this.registrationData.registrationSubMode ==
          RegistrationSubMode.CGUValidation
      );
    },
  },

  watch: {
    "userData.firstName": {
      handler() {
        this.refreshLogin();
      },
    },
    "userData.lastName": {
      handler() {
        this.refreshLogin();
      },
    },
  },
});
</script>

<style scoped>
.identifier-title {
  font-size: 25px;
  color: #2fa1ba;
  margin-top: 30px;
  margin-bottom: 30px;
}
</style>
